<template>
  <layout width="428">
    <template slot="header">Change schema</template>
    <v-form
      autocomplete="off"
      ref="form"
      class="mt-4"
      v-model="isValid"
      lazy-validation
    >
      <v-card-text class="py-0">
        <v-autocomplete
          clearable
          :items="schemas"
          item-text="name"
          item-value="id"
          label="Schema"
          v-model="selectedSchema"
          class="ma-0"
          :rules="rules.required"
          required
        ></v-autocomplete>
        <p class="body-2 mt-1">
          Changing the schema can lead to data loss or incorrect processing, as
          well as cause errors in other applications.
        </p>
      </v-card-text>
    </v-form>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click="$emit('close')">
        cancel
      </v-btn>
      <v-btn color="primary" :loading="loading" text @click="saveSchema">
        save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import useSchemas from '@/api/schemas';
import { onMounted, ref } from '@vue/composition-api';
import Layout from '@/layouts/LayoutPopup';
import { useMutation } from '@vue/apollo-composable';
import gql from '@/api/objects/item.graphql';
export default {
  name: 'EditScheme',
  components: {
    Layout
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: String,
      default: ''
    },
    schemaId: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit, refs, root }) {
    const { schemas: schemasApi } = new useSchemas();
    const { mutate: updateObject } = useMutation(gql.update);
    const schemas = ref([]);
    const selectedSchema = ref('');
    const isValid = ref(true);
    const rules = ref({
      required: [v => !!v || 'Schema is required']
    });

    const saveSchema = async () => {
      refs.form.validate();
      await root.$nextTick();
      if (!props.schemaId) {
        if (isValid.value) {
          emit('save', selectedSchema.value);
        }
      } else {
        if (isValid.value) {
          if (selectedSchema.value !== props.schemaId) {
            updateObject({
              input: {
                id: props.objectId,
                patch: {
                  schemaId: selectedSchema.value
                }
              }
            }).then(() => {
              emit('close');
            });
          } else {
            emit('close');
          }
        }
      }
    };

    onMounted(() => {
      schemasApi.loadPureSchemata(props.type).then(r => {
        schemas.value = r.schemata;
        if (props.schemaId) {
          selectedSchema.value = props.schemaId;
        }
      });
    });

    return {
      schemas,
      saveSchema,
      selectedSchema,
      isValid,
      rules
    };
  }
};
</script>
